module.exports = __webpack_public_path__ + "img/tittle.a206f648.svg";